import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import {
  LOAD_CONTENT,
  SET_DATA,
  DL_PAGE_LOADED
} from './confirmation';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {NORMALIZE_DATA} from '../../../dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';

// WATCHERS
export function* loadCustomerWatch() {
  yield takeLatest(LOAD_CONTENT, loadCustomerWorker);
}

export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

// WORKERS
export function* loadCustomerWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true}));

    const errorPage = yield select(errorPageByFlow);
    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'context'},
      {state: 'moversConfirmation'}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield put({
      type: DL_PAGE_LOADED
    });

    yield put(hideGlobalSpinner());
  } catch(e) {
    yield put(hideGlobalSpinner());
    browserHistory.push(navigationRoutes[navigationSteps.movers.ERROR].path);
  }
}

export function* normalizeWorker({key, data, meta}) {
  if (key !== 'moversConfirmation') {
    return;
  }

  yield put({
    type: SET_DATA,
    payload: {
      ...meta,
      content: data
    }
  });
}

export default function* moversCancelSagas() {
  yield [
    fork(loadCustomerWatch),
    fork(normalizeWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/confirmation/confirmationSagas.js
 **/